import React from "react";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { colors, fonts, size } from "../../ColorFont/color";
import { useTranslation } from "react-i18next";

const Support = ({ faqsPage }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ margin: "0 auto", maxWidth: "1600px", px: 0 }}>


      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: 4,
            borderRadius: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            cursor: "pointer",
            border: `1px solid ${colors.border}`,
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
            },
          }}
          onClick={() => {
            faqsPage();
          }}
        >
          <HelpOutlineIcon
            sx={{ color: colors.primary_dark, fontSize: 40 }}
          />
          <Typography
            sx={{
              fontWeight: 700,
              marginTop: 2,
              fontFamily: fonts.poppins,
              fontSize: "24px",
              color: colors.primary_dark,
            }}
          >
            FAQs
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              marginTop: 1.5,
              fontFamily: fonts.poppins,
              fontSize: "15px",
              color: colors.text,
              lineHeight: 1.6,
            }}
          >
            {t("checkFAQs")}
          </Typography>
        </Paper>

        <Paper
          elevation={0}
          sx={{
            padding: 4,
            borderRadius: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            cursor: "pointer",
            border: `1px solid ${colors.border}`,
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
            },
          }}
        >
          <EmailIcon sx={{ color: colors.primary_dark, fontSize: 40 }} />
          <Typography
            sx={{
              fontWeight: 700,
              marginTop: 2,
              fontFamily: fonts.poppins,
              fontSize: "24px",
              color: colors.primary_dark,
            }}
          >
            {t("emailSupport")}
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              marginTop: 1.5,
              fontFamily: fonts.poppins,
              fontSize: "15px",
              color: colors.text,
              lineHeight: 1.6,
            }}
          >
            {t("reachUs")}{" "}
            <a
              href="mailto:krushisetuofficial@gmail.com"
              style={{
                color: colors.primary_dark,
                textDecoration: "none",
                fontWeight: 700,
              }}
            >
              krushisetuofficial@gmail.com
            </a>{" "}
            {t("for")}
          </Typography>
        </Paper>

        <Paper
          elevation={0}
          sx={{
            padding: 4,
            borderRadius: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            cursor: "pointer",
            border: `1px solid ${colors.border}`,
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
            },
          }}
        >
          <PhoneIcon sx={{ color: colors.primary_dark, fontSize: 40 }} />
          <Typography
            sx={{
              fontWeight: 700,
              marginTop: 2,
              fontFamily: fonts.poppins,
              fontSize: "24px",
              color: colors.primary_dark,
            }}
          >
            {t("callUs")}
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              marginTop: 1.5,
              fontFamily: fonts.poppins,
              fontSize: "15px",
              color: colors.text,
              lineHeight: 1.6,
            }}
          >
            {t("supportTeam")}{" "}
            <a
              href="tel:+917040180680"
              style={{
                color: colors.primary_dark,
                textDecoration: "none",
                fontWeight: 700,
              }}
            >
              +91 7040180680
            </a>{" "}
            {t("during")}
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default Support;
